import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function EditIcon({
  color = RoutalPalette.primary40,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) {
  return (
    <SvgIcon {...props} viewBox="0 0 22 20" style={{ width: `20px`, height: `20px`, ...props.style }}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.68971 1.31282C3.13667 0.863918 3.75204 0.60376 4.40324 0.60376H11.0004C11.2867 0.60376 11.5187 0.819124 11.5187 1.08479C11.5187 1.35046 11.2867 1.56582 11.0004 1.56582H4.40324C4.05463 1.56582 3.71115 1.70457 3.45113 1.96571C3.18984 2.22814 3.03669 2.59166 3.03669 2.97789V16.2296C3.03669 16.6159 3.18984 16.9794 3.45113 17.2418C3.71115 17.503 4.05463 17.6417 4.40324 17.6417H17.5975C17.9461 17.6417 18.2896 17.503 18.5496 17.2418C18.8109 16.9794 18.9641 16.6159 18.9641 16.2296V9.60376C18.9641 9.33809 19.1961 9.12273 19.4824 9.12273C19.7687 9.12273 20.0008 9.33809 20.0008 9.60376V16.2296C20.0008 16.8476 19.7567 17.4471 19.311 17.8947C18.8641 18.3436 18.2487 18.6038 17.5975 18.6038H4.40324C3.75204 18.6038 3.13667 18.3436 2.68971 17.8947C2.24403 17.4471 2 16.8476 2 16.2296V2.97789C2 2.35997 2.24403 1.76044 2.68971 1.31282Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.4824 1.03669C19.0897 1.03669 18.713 1.19272 18.4353 1.47044L9.58355 10.3222L8.88545 13.1146L11.6778 12.4165L20.5296 3.56473C20.8073 3.28701 20.9633 2.91034 20.9633 2.51758C20.9633 2.12483 20.8073 1.74816 20.5296 1.47044C20.2518 1.19272 19.8752 1.03669 19.4824 1.03669ZM17.7022 0.737383C18.1744 0.265245 18.8147 0 19.4824 0C20.1501 0 20.7905 0.265245 21.2626 0.737383C21.7348 1.20952 22 1.84988 22 2.51758C22 3.18529 21.7348 3.82564 21.2626 4.29778L12.3094 13.251C12.2429 13.3175 12.1597 13.3646 12.0686 13.3874L8.29877 14.3298C8.12213 14.374 7.93527 14.3222 7.80652 14.1935C7.67778 14.0647 7.62602 13.8779 7.67018 13.7013L8.61263 9.93146C8.63541 9.84031 8.68254 9.75708 8.74897 9.69065L17.7022 0.737383Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3125 13.2735L8.73442 9.69546L9.46747 8.9624L13.0455 12.5405L12.3125 13.2735Z"
          fill={color}
        />
      </g>
    </SvgIcon>
  );
}
